import _ from 'underscore';
import StringListInput from '@bingads-webui-component-legacy/string-list-input/view/string-list-input';

const schema = window.globalLegacySchema.get('StructuredSnippetAdExtension');
const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/adextensions');

export default class extends StringListInput {
  initialize({
    observable,
    field,
  }) {
    const opts = {
      schema: schema.properties.Texts,
      values: observable(),
      validatorMessages: {
        pattern: i18n.get('StructuredSnippet_Texts_Should_Exclude_Comma_SemiColon'),
      },
      id: field.id,
      labelledby: `${field.id}-Label`,
      describedby: `${field.id}-Validation`,
    };

    this.on('update', (newValues) => {
      observable(_.filter(newValues, Boolean));
    });

    super.initialize(opts);
  }
}
